var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "accent--text pb-4"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Документы")])]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', [_vm.documentsList.length ? _vm._l(_vm.documentsList, function (item, i) {
    return _c('v-row', {
      key: i
    }, [_c('v-col', {
      staticClass: "d-flex px-0 pb-0",
      on: {
        "click": function click($event) {
          return _vm.selectItem(item);
        }
      }
    }, [_c('v-chip', {
      staticClass: "accent--text",
      attrs: {
        "link": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "color": _vm.toggleColorEye(item)
      }
    }, [_vm._v(" mdi-eye-outline ")]), _vm._v(" " + _vm._s(item.originalName ? item.originalName : item.fileName) + " ")], 1)], 1)], 1);
  }) : [_c('v-row', [_c('v-col', {
    staticClass: "pt-2 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("Документы не были приложены")])])], 1)]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }